
import { defineComponent } from "vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    IntegerControl,
  },
  props: {
    model: { required: true },
  },
  methods: {},
  created(){
    this.modelLocal = this.model;
  },
  data(){
    return {
      modelLocal: null,
      weight: [{name: "cabinAxle", top: 345, left: 120},
        {name: "tractorFirstAxle", top: 345, left: 335}, 
        {name: "tractorSecondAxle", top: 345, left: 435}, 
        {name: "semitrailerFirstAxle", top: 345, left: 660}],
      distance: [{name: "tractorAxlesDistanceFirst", top: 152, left: 241, width: 40},
        {name: "tractorAxlesDistanceSecond", top: 152, left: 295, width: 56},
        {name: "tractorAxlesDistanceThird", top: 152, left: 386, width: 56},
        {name: "tractorCabinAxlesDistance", top: 290, left: 225, width: 56},
        {name: "tractorSemitrailerAxlesDistance", top: 113, left: 450, width: 56}],
    };
  },
});
